import { BaseModel } from "sjs-base-model";
import UserBasicInfoModel from "../user/UserBasicInfoModel";
import KaikoItemModel from "../filterableProducts/kaiko/KaikoItemModel";

export default class FilterableSubscriptionRequestModel extends BaseModel {
    id = 0;
    userInfo = [UserBasicInfoModel]
    subscriptionTypeName = "";
    startDate = 0;
    baseCurrencies = [KaikoItemModel];
    state = "";
    productName = "";

    constructor(data) {
        super();
        this.update(data);
    }
}
